import React from 'react';
import styled from 'styled-components';

const FooterWrapper = styled.footer`
  height: 40px;
  justify-content: center;
  text-align: center;
  display: flex;
  background-color: black;
  color: white;
  margin-top: 50px;
  font-weight: 100;
  font-size: 12px;
  /* bottom: 0; */
`;

const Footer = () => (
  <>
    <FooterWrapper>
      <p>© Daniel Łakomiec jjlakomiec@gmail.com 2022r.</p>
    </FooterWrapper>
  </>
);

export default Footer;
